<template>
  <div id="app"  v-loading.fullscreen.lock="fullscreenLoading">
    <link rel="shortcut icon" type="image/x-icon" href="static/favicon.ico">
    <title>智眼金睛企业后台管理系统</title>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'fullscreenLoading'
    ])
  }
}
</script>
<style lang="scss">
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
</style>
